import { CompType, isString } from '@aloft/toolkit-shared';
import { Block, Button, Flex, Typography } from '@aloft/toolkit-sui';

import { CompTypeBadge } from '../../components/CompTypeBadge.tsx';
import { ToastOptions } from './types.ts';

export const RenderToast = ({
  title,
  body,
  compType,
  onClick,
  isClickable,
  action,
  alertType,
  alertPropertyID,
  alertSeverity,
}: {
  title: ToastOptions['title'];
  body: ToastOptions['body'];
  compType?: CompType;
  onClick?: VoidFunction;
  isClickable?: boolean;
  action?: {
    text: string;
    onClick: () => void;
  };
  alertType?: ToastOptions['alertType'];
  alertPropertyID?: ToastOptions['alertPropertyID'];
  alertSeverity?: ToastOptions['type'];
}) => {
  let paragraphs: string[] = [];
  if (Array.isArray(body)) {
    paragraphs = body;
  } else if (isString(body)) {
    paragraphs = [body];
  }

  return (
    <Flex
      alignItems="center"
      onClick={onClick}
      __dangerDoNotUseSx={isClickable ? { cursor: 'pointer', minWidth: 0 } : { minWidth: 0 }}
      {...(alertType ? { 'data-alert-type': alertType } : {})}
      {...(alertPropertyID ? { 'data-alert-property-id': alertPropertyID } : {})}
      {...(alertSeverity ? { 'data-alert-severity': alertSeverity } : {})}
    >
      <Block
        flex={1}
        __dangerDoNotUseSx={{
          minWidth: 0,
        }}
      >
        <Typography variant="h4" __dangerDoNotUseSx={{ marginBottom: 1 }}>
          {title}
        </Typography>
        <Flex alignItems="flex-end">
          {paragraphs.map((x) => (
            <Typography key={x}>{x}</Typography>
          ))}
          {action && <Button text={action.text} onClick={action.onClick} marginLeft="1.5rem" />}
        </Flex>
      </Block>
      {compType && (
        <Flex alignItems="flex-start">
          <CompTypeBadge compType={compType} />
        </Flex>
      )}
    </Flex>
  );
};
